module.exports = __webpack_public_path__ + "static/media/pro_2.62636a31.jpg";